import {Component, Input, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {CmsLinkComponent, CmsService} from '@spartacus/core';

@Component({
  selector: 'dcp-contact-iframe',
  templateUrl: './contact-iframe.component.html',
  styleUrls: ['./contact-iframe.component.scss']
})
export class ContactIframeComponent implements OnInit {

  private linkComponentId: string = 'Sap4MeContactSupportCtaLink';
  iFrameLink$: Observable<CmsLinkComponent>;
  @Input() iFrameTitle: any;

  constructor(
    private cmsService: CmsService,
  ) {
  }

  ngOnInit(): void {
    this.iFrameLink$ = this.cmsService.getComponentData(this.linkComponentId);
  }

}
